'use client';

import { BiSolidHome } from 'react-icons/bi';

import RegisterForm from '@/app/(auth)/register/container/RegisterForm';
import withAuth from '@/components/hoc/withAuth';
import UnstyledLink from '@/components/links/UnstyledLink';
import NextImage from '@/components/NextImage';
import Typography from '@/components/Typography';

export default withAuth(RegisterPage, 'public');
function RegisterPage() {
  return (
    <section className='relative flex min-h-screen items-center justify-center'>
      <NextImage
        src='/register/img-pojokbawah.png'
        className='absolute bottom-0 right-0 z-0 hidden w-[55%] lg:block'
        imgClassName='absolute bottom-0 right-0 z-0 w-[55%]'
        alt='decor-bawah'
        width={281}
        height={177}
      />
      <section className='z-10 mx-8 py-10 md:mx-16 md:py-20'>
        <div className='mb-4 space-y-4'>
          <UnstyledLink
            href='/'
            className='flex items-center space-x-2 text-primary-info-main underline hover:text-primary-info-hover hover:no-underline'
          >
            <BiSolidHome size={24} />
            <Typography
              as='p'
              variant='btn'
              weight='semibold'
              className='text-base'
            >
              Kembali ke Home
            </Typography>
          </UnstyledLink>
        </div>

        <RegisterForm />

        <div
          className='flex h-[12px] w-full items-center justify-center rounded-b-2xl bg-gradient-to-r'
          style={{
            background:
              'linear-gradient(to right, #3BD09A 0%, #54C4DB 25%, #FC3E3E 60%, #FFCF55 100%)',
            zIndex: 0,
          }}
        />
      </section>
    </section>
  );
}
